import React, { useState, useEffect, useMemo } from "react"
import axios from "axios";
import { InputGroup } from "react-bootstrap";
import { useTranslation } from "react-i18next";

function DetailReviewSection(props) {
    const { t, i18n } = useTranslation('common');

    const [review, setReview] = useState([]);
    const [ratings, setRatings] = useState([5, 4, 3, 2, 1]);
    const [score, setScore] = useState([]);
 //console.log(props?.rating_data);
    useEffect(() => {
        // var url = props.site_url + "/wp-json/myapi/v1/get_ratingdata";
        // const data = { post_id: props?.data?.ID };
        // axios.post(url, data).then((response) => {
        //     if (!response?.data?.error) {
                  
                setReview(props?.rating_data);
        //     }
        // });
    }, [])

    function calculate_rating(rating_data) {
        let total = 0;
        rating_data.map(function (element, index) {
            total = parseInt(element.rating) + parseInt(total);
        });
        return total / 5;
    }

    function create_stars(rating_data) {
        // for (let i = 0; i < cars.length; i++) {
        //     text += cars[i] + "<br>";
        // }
    }

    function open_score(obj) {
        const element = obj?.target.parentNode.parentNode;
        element.getElementsByClassName('rem_detailed_score')[0].style.display = 'block';
        element.getElementsByClassName('rem_hide_button')[0].style.display = 'flex';
        element.getElementsByClassName('rem_show_score')[0].style.display = 'none';
    }

    function close_score(obj) {
        const element = obj?.target.parentNode.parentNode;
        element.getElementsByClassName('rem_detailed_score')[0].style.display = 'none';
        element.getElementsByClassName('rem_hide_button')[0].style.display = 'none';
        element.getElementsByClassName('rem_show_score')[0].style.display = 'flex';
    }

    return (<section class="client_riview_section rem_nav_section" id="review_section">
        <div class="container_size">
            <h3>{t('Reviews')+" "}

                ({(review) ? review.length : 0})
            </h3>
            {(review && review != '') ? review.map(function (obj, i) {

                return (
                    <div>
                        <div class="review-main-details">
                            <div class="review-main-details-box">
                                <div class="review-star">
                                    <div class="review-form-star-rating">
                                        <span class="ratingsStar">
                                            <div class="rem_Stars" style={{ '--rating': Number(obj?.total).toFixed(2) }}>
                                            </div>
                                        </span>
                                    </div>
                                </div>
                            </div>

                            <div class="review-main-details-box_text">
                                <div class="review_text">
                              
                                    <h4>{obj?.fullname} </h4><span>{obj?.date}</span>
                                    <p>{obj?.msg.replace( /(<([^>]+)>)/ig, '')}</p>
                                </div>
                                <div class="review-category review-list_main rem_hide rem_detailed_score">
                                    <ul>
                                        <li class="review-number">
                                            <div class="review_star review_text_p">
                                                <p>{t('Initial Impression')}</p>
                                                <div class="review-form-star-rating">
                                                    {
                                                        ratings.map(function (element, index) {
                                                            if (obj?.rem_review_rating >= element) {
                                                                return (<span>
                                                                    <input checked type="radio" id={'c' + index + 'c1' + obj?.rem_post_id + '-5-stars'} name={'rating' + index + 'c1' + obj?.rem_post_id} value={index + 'c1' + obj?.rem_post_id} />
                                                                    <label for={'c' + index + 'c1' + obj?.rem_post_id + '-5-stars'} class="star">★</label>
                                                                </span>)
                                                            } else {
                                                                return (<span>
                                                                    <input type="radio" id={'c' + index + 'c1' + obj?.rem_post_id + '-5-stars'} name={'rating' + index + 'c1' + obj?.rem_post_id} value={index + 'c1' + obj?.rem_post_id} />
                                                                    <label for={'c' + index + 'c1' + obj?.rem_post_id + '-5-stars'} class="star">★</label>
                                                                </span>)
                                                            }
                                                        })
                                                    }
                                                </div>
                                            </div>
                                        </li>

                                        <li class="review-number">
                                            <div class="review_star review_text_p">
                                                <p>{t('Punctuality')}</p>
                                                <div class="review-form-star-rating">

                                                    {
                                                        ratings.map(function (element, index) {
                                                            if (obj?.rem_Punctuality_rating >= element) {
                                                                return (<span>
                                                                    <input checked type="radio" id={'c' + index + 'c2' + obj?.rem_post_id + '-5-stars'} name={'rating' + index + 'c2' + obj?.rem_post_id} value={index + 'c2' + obj?.rem_post_id} />
                                                                    <label for={'c' + index + 'c2' + obj?.rem_post_id + '-5-stars'} class="star">★</label>
                                                                </span>)
                                                            } else {
                                                                return (<span>
                                                                    <input type="radio" id={'c' + index + 'c2' + obj?.rem_post_id + '-5-stars'} name={'rating' + index + 'c2' + obj?.rem_post_id} value={index + 'c2' + obj?.rem_post_id} />
                                                                    <label for={'c' + index + 'c2' + obj?.rem_post_id + '-5-stars'} class="star">★</label>
                                                                </span>)
                                                            }
                                                        })
                                                    }

                                                </div>
                                            </div>
                                        </li>

                                        <li class="review-number">
                                            <div class="review_star review_text_p">
                                                <p>{t('Cleanliness')}</p>
                                                <div class="review-form-star-rating">

                                                    {
                                                        ratings.map(function (element, index) {
                                                            if (obj?.rem_Cleanliness_rating >= element) {
                                                                return (<span>
                                                                    <input checked type="radio" id={'c' + index + 'c3' + obj?.rem_post_id + '-5-stars'} name={'rating' + index + 'c3' + obj?.rem_post_id} value={index + 'c3' + obj?.rem_post_id} />
                                                                    <label for={'c' + index + 'c3' + obj?.rem_post_id + '-5-stars'} class="star">★</label>
                                                                </span>)
                                                            } else {
                                                                return (<span>
                                                                    <input type="radio" id={'c' + index + 'c3' + obj?.rem_post_id + '-5-stars'} name={'rating' + index + 'c3' + obj?.rem_post_id} value={index + 'c3' + obj?.rem_post_id} />
                                                                    <label for={'c' + index + 'c3' + obj?.rem_post_id + '-5-stars'} class="star">★</label>
                                                                </span>)
                                                            }
                                                        })
                                                    }


                                                </div>
                                            </div>
                                        </li>
                                        <li class="review-number">
                                            <div class="review_star review_text_p">
                                                <p>{t('Quality')}</p>
                                                <div class="review-form-star-rating">


                                                    {
                                                        ratings.map(function (element, index) {
                                                            if (obj?.rem_quality_rating >= element) {
                                                                return (<span>
                                                                    <input checked type="radio" id={'c' + index + 'c4' + obj?.rem_post_id + '-5-stars'} name={'rating' + index + 'c4' + obj?.rem_post_id} value={index + 'c4' + obj?.rem_post_id} />
                                                                    <label for={'c' + index + 'c4' + obj?.rem_post_id + '-5-stars'} class="star">★</label>
                                                                </span>)
                                                            } else {
                                                                return (<span>
                                                                    <input type="radio" id={'c' + index + 'c4' + obj?.rem_post_id + '-5-stars'} name={'rating' + index + 'c4' + obj?.rem_post_id} value={index + 'c4' + obj?.rem_post_id} />
                                                                    <label for={'c' + index + 'c4' + obj?.rem_post_id + '-5-stars'} class="star">★</label>
                                                                </span>)
                                                            }
                                                        })
                                                    }

                                                </div>
                                            </div>
                                        </li>

                                        <li class="review-number">
                                            <div class="review_star review_text_p">
                                                <p>{t('Value')}</p>
                                                <div class="review-form-star-rating">

                                                    {
                                                        ratings.map(function (element, index) {
                                                            if (obj?.rem_Value_rating >= element) {
                                                                return (<span>
                                                                    <input checked type="radio" id={'c' + index + 'c5' + obj?.rem_post_id + '-5-stars'} name={'rating' + index + 'c5' + obj?.rem_post_id} value={index + 'c5' + obj?.rem_post_id} />
                                                                    <label for={'c' + index + 'c5' + obj?.rem_post_id + '-5-stars'} class="star">★</label>
                                                                </span>)
                                                            } else {
                                                                return (<span>
                                                                    <input type="radio" id={'c' + index + 'c5' + obj?.rem_post_id + '-5-stars'} name={'rating' + index + 'c5' + obj?.rem_post_id} value={index + 'c5' + obj?.rem_post_id} />
                                                                    <label for={'c' + index + 'c5' + obj?.rem_post_id + '-5-stars'} class="star">★</label>
                                                                </span>)
                                                            }
                                                        })
                                                    }

                                                </div>
                                            </div>
                                        </li>

                                        <li class="review-number">
                                            <div class="review_star review_text_p">
                                                <p>{t('Overall rating')}</p>
                                                <div class="review-form-star-rating">
                                                    {
                                                        ratings.map(function (element, index) {
                                                            if (obj?.rem_overall_rating >= element) {
                                                                return (<span>
                                                                    <input checked type="radio" id={'c' + index + 'c6' + obj?.rem_post_id + '-5-stars'} name={'rating' + index + 'c6' + obj?.rem_post_id} value={index + 'c6' + obj?.rem_post_id} />
                                                                    <label for={'c' + index + 'c6' + obj?.rem_post_id + '-5-stars'} class="star">★</label>
                                                                </span>)
                                                            } else {
                                                                return (<span>
                                                                    <input type="radio" id={'c' + index + 'c6' + obj?.rem_post_id + '-5-stars'} name={'rating' + index + 'c6' + obj?.rem_post_id} value={index + 'c6' + obj?.rem_post_id} />
                                                                    <label for={'c' + index + 'c6' + obj?.rem_post_id + '-5-stars'} class="star">★</label>
                                                                </span>)
                                                            }
                                                        })
                                                    }
                                                </div>
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                            <div class="show-hide-btn rem_hide_button rem_hide">
                                <button onClick={close_score}>{t('Hide')}</button>
                            </div>

                            <div class="show-hide-btn rem_show_score" >
                                <button onClick={open_score}>{t('Scores')}</button>
                            </div>

                        </div>
                        {(obj?.admin_reply) ?
                            <div id="main1">
                                <div class="sec_reply_mgs2">
                                    {/* <h4 class="name_heading">{obj?.current_user} - {obj?.reply_date}</h4> */}
                                    <p class="name_para">{obj?.admin_reply}</p>
                                </div>
                            </div>
                            : ''
                        }
                    </div>

                );
            })
                : <p class="rem_no_reviews">{t('No Reviews')}</p>
            }


            {/* <button class="more_reviews-btn">More Reviews</button> */}
        </div>
    </section>);
}

export default DetailReviewSection;